export default __webpack_public_path__ + "static/media/cross-platform.8d39b8c9.svg";